import { ROLE_WILDCARD_PUBLIC, UnespCoreMenuItem } from '@unesp/core'

export const menuPropg: UnespCoreMenuItem[] = [
  // PROPG
  // {
  //   displayName: 'Relatórios',
  //   iconName: 'inventory',
  //   roles: ['PROPG'],
  //   order: 1,
  //   children: [
  //     {
  //       displayName: 'Programas',
  //       iconName: 'navigate_next',
  //       roles: ['PROPG'],
  //       order: 1,
  //       children: [
  //         {
  //           displayName: 'Documentação',
  //           iconName: 'navigate_next',
  //           roles: ['PROPG'],
  //           order: 1,
  //           route: 'em-desenvolvimento',
  //         },
  //         {
  //           displayName: 'Credenciados',
  //           iconName: 'navigate_next',
  //           roles: ['PROPG'],
  //           order: 2,
  //           route: 'em-desenvolvimento',
  //         },
  //         {
  //           displayName: 'Coordenações',
  //           iconName: 'navigate_next',
  //           roles: ['PROPG'],
  //           order: 3,
  //           route: 'em-desenvolvimento',
  //         },
  //         {
  //           displayName: 'R.Conselho - Docente',
  //           iconName: 'navigate_next',
  //           roles: ['PROPG'],
  //           order: 4,
  //           route: 'em-desenvolvimento',
  //         },
  //         {
  //           displayName: 'R.Conselho - Aluno',
  //           iconName: 'navigate_next',
  //           roles: ['PROPG'],
  //           order: 5,
  //           route: 'em-desenvolvimento',
  //         },
  //         {
  //           displayName: 'Disciplinas',
  //           iconName: 'navigate_next',
  //           roles: ['PROPG'],
  //           order: 6,
  //           children: [
  //             {
  //               displayName: 'Estrutura Curricular',
  //               iconName: 'navigate_next',
  //               roles: ['PROPG'],
  //               order: 1,
  //               route: 'em-desenvolvimento',
  //             },
  //             {
  //               displayName: 'Ministradas/Modelo 1',
  //               iconName: 'navigate_next',
  //               roles: ['PROPG'],
  //               order: 2,
  //               route: 'em-desenvolvimento',
  //             },
  //             {
  //               displayName: 'Ministradas/Modelo 2',
  //               iconName: 'navigate_next',
  //               roles: ['PROPG'],
  //               order: 3,
  //               route: 'em-desenvolvimento',
  //             },
  //           ],
  //         },
  //         {
  //           displayName: 'Bolsistas',
  //           iconName: 'navigate_next',
  //           roles: ['PROPG'],
  //           order: 7,
  //           route: 'em-desenvolvimento',
  //         },
  //         {
  //           displayName: 'Dissertações/Teses',
  //           iconName: 'navigate_next',
  //           roles: ['PROPG'],
  //           order: 8,
  //           route: 'em-desenvolvimento',
  //         },
  //         {
  //           displayName: 'Resumo',
  //           iconName: 'navigate_next',
  //           roles: ['PROPG'],
  //           order: 9,
  //           route: 'em-desenvolvimento',
  //         },
  //       ],
  //     },
  //     {
  //       displayName: 'Discentes',
  //       iconName: 'navigate_next',
  //       roles: ['PROPG'],
  //       order: 2,
  //       children: [
  //         {
  //           displayName: 'Por Programa',
  //           iconName: 'navigate_next',
  //           roles: ['PROPG'],
  //           order: 1,
  //           route: 'em-desenvolvimento',
  //         },
  //         {
  //           displayName: 'Por Região',
  //           iconName: 'navigate_next',
  //           roles: ['PROPG'],
  //           order: 2,
  //           route: 'em-desenvolvimento',
  //         },
  //         {
  //           displayName: 'Prorrogação',
  //           iconName: 'navigate_next',
  //           roles: ['PROPG'],
  //           order: 3,
  //           route: 'em-desenvolvimento',
  //         },
  //       ],
  //     },
  //     {
  //       displayName: 'Docentes',
  //       iconName: 'navigate_next',
  //       roles: ['PROPG'],
  //       order: 3,
  //       children: [
  //         {
  //           displayName: 'Orientações',
  //           iconName: 'navigate_next',
  //           roles: ['PROPG'],
  //           order: 1,
  //           route: 'em-desenvolvimento',
  //         },
  //         {
  //           displayName: 'Orientações',
  //           iconName: 'navigate_next',
  //           roles: ['PROPG'],
  //           order: 2,
  //           route: 'em-desenvolvimento',
  //         },
  //         {
  //           displayName: 'Linha de Pesquisa',
  //           iconName: 'navigate_next',
  //           roles: ['PROPG'],
  //           order: 3,
  //           route: 'em-desenvolvimento',
  //         },
  //       ],
  //     },
  //     {
  //       displayName: 'Diretor/DTA/STPG',
  //       iconName: 'navigate_next',
  //       roles: ['PROPG'],
  //       order: 4,
  //       route: 'em-desenvolvimento',
  //     },
  //   ],
  // },
  // {
  //   displayName: 'Dados Estatísticos',
  //   iconName: 'bar_chart',
  //   roles: ['PROPG'],
  //   order: 2,
  //   children: [
  //     {
  //       displayName: 'Estrangeiros',
  //       iconName: 'navigate_next',
  //       roles: ['PROPG'],
  //       order: 1,
  //       children: [
  //         {
  //           displayName: 'Por Programa',
  //           iconName: 'navigate_next',
  //           roles: ['PROPG'],
  //           order: 1,
  //           route: 'em-desenvolvimento',
  //         },
  //         {
  //           displayName: 'Por Área de Concentração',
  //           iconName: 'navigate_next',
  //           roles: ['PROPG'],
  //           order: 2,
  //           route: 'em-desenvolvimento',
  //         },
  //         {
  //           displayName: 'Por País - Ingressantes',
  //           iconName: 'navigate_next',
  //           roles: ['PROPG'],
  //           order: 3,
  //           route: 'em-desenvolvimento',
  //         },
  //         {
  //           displayName: 'Por País - Matriculados',
  //           iconName: 'navigate_next',
  //           roles: ['PROPG'],
  //           order: 4,
  //           route: 'em-desenvolvimento',
  //         },
  //         {
  //           displayName: 'Estrangeiro/Brasileiro',
  //           iconName: 'navigate_next',
  //           roles: ['PROPG'],
  //           order: 5,
  //           route: 'em-desenvolvimento',
  //         },
  //       ],
  //     },
  //     {
  //       displayName: 'Pós em Números',
  //       iconName: 'navigate_next',
  //       roles: ['PROPG'],
  //       order: 2,
  //       route: 'em-desenvolvimento',
  //     },
  //     {
  //       displayName: 'Matriculados',
  //       iconName: 'navigate_next',
  //       roles: ['PROPG'],
  //       order: 3,
  //       route: 'em-desenvolvimento',
  //     },
  //     {
  //       displayName: 'Formados',
  //       iconName: 'navigate_next',
  //       roles: ['PROPG'],
  //       order: 4,
  //       route: 'em-desenvolvimento',
  //     },
  //     {
  //       displayName: 'Desligados/Suspensos',
  //       iconName: 'navigate_next',
  //       roles: ['PROPG'],
  //       order: 5,
  //       route: 'em-desenvolvimento',
  //     },
  //     {
  //       displayName: 'Necessidades Especiais',
  //       iconName: 'navigate_next',
  //       roles: ['PROPG'],
  //       order: 6,
  //       route: 'em-desenvolvimento',
  //     },
  //     {
  //       displayName: 'Alunos Regulares',
  //       iconName: 'navigate_next',
  //       roles: ['PROPG'],
  //       order: 7,
  //       route: 'em-desenvolvimento',
  //     },
  //     {
  //       displayName: 'Alunos Bolsistas',
  //       iconName: 'navigate_next',
  //       roles: ['PROPG'],
  //       order: 8,
  //       route: 'em-desenvolvimento',
  //     },
  //     {
  //       displayName: 'Quadro Resumo',
  //       iconName: 'navigate_next',
  //       roles: ['PROPG'],
  //       order: 9,
  //       route: 'em-desenvolvimento',
  //     },
  //   ],
  // },
  // {
  //   displayName: 'Reconhecimentos',
  //   iconName: 'gavel',
  //   roles: ['PROPG'],
  //   order: 3,
  //   route: 'em-desenvolvimento',
  // },
  // {
  //   displayName: 'Conceitos',
  //   iconName: 'my_location',
  //   roles: ['PROPG'],
  //   order: 4,
  //   route: 'em-desenvolvimento',
  // },
  // {
  //   displayName: 'Programas',
  //   iconName: 'book',
  //   roles: ['PROPG'],
  //   order: 5,
  //   route: 'em-desenvolvimento',
  // },
  // {
  //   displayName: 'Disciplinas',
  //   iconName: 'format_list_bulleted',
  //   roles: ['PROPG'],
  //   order: 6,
  //   route: 'em-desenvolvimento',
  // },
  // {
  //   displayName: 'Linhas de Pesquisa',
  //   iconName: 'plagiarism',
  //   roles: ['PROPG'],
  //   order: 7,
  //   route: 'em-desenvolvimento',
  // },
  // {
  //   displayName: 'Projetos',
  //   iconName: 'receipt_long',
  //   roles: ['PROPG'],
  //   order: 8,
  //   route: 'em-desenvolvimento',
  // },
  // {
  //   displayName: 'Docentes',
  //   iconName: 'attribution',
  //   roles: ['PROPG'],
  //   order: 9,
  //   route: 'em-desenvolvimento',
  // },
  // {
  //   displayName: 'Discentes',
  //   iconName: 'account_circle',
  //   roles: ['PROPG'],
  //   order: 10,
  //   children: [
  //     {
  //       displayName: 'Dados Cadastrais',
  //       iconName: 'navigate_next',
  //       roles: ['PROPG'],
  //       order: 1,
  //       route: 'em-desenvolvimento',
  //     },
  //     {
  //       displayName: 'Horário de Aulas',
  //       iconName: 'navigate_next',
  //       roles: ['PROPG'],
  //       order: 2,
  //       route: 'em-desenvolvimento',
  //     },
  //     {
  //       displayName: 'Situação Acadêmica',
  //       iconName: 'navigate_next',
  //       roles: ['PROPG'],
  //       order: 3,
  //       route: 'em-desenvolvimento',
  //     },
  //     {
  //       displayName: 'Aproveitamento de Crédito',
  //       iconName: 'navigate_next',
  //       roles: ['PROPG'],
  //       order: 4,
  //       route: 'em-desenvolvimento',
  //     },
  //     {
  //       displayName: 'Atividades Complementares',
  //       iconName: 'navigate_next',
  //       roles: ['PROPG'],
  //       order: 5,
  //       route: 'em-desenvolvimento',
  //     },
  //     {
  //       displayName: 'Proficiência em Línguas',
  //       iconName: 'navigate_next',
  //       roles: ['PROPG'],
  //       order: 6,
  //       route: 'em-desenvolvimento',
  //     },
  //     {
  //       displayName: 'Ocorrências',
  //       iconName: 'navigate_next',
  //       roles: ['PROPG'],
  //       order: 7,
  //       route: 'em-desenvolvimento',
  //     },
  //     {
  //       displayName: 'Bolsas',
  //       iconName: 'navigate_next',
  //       roles: ['PROPG'],
  //       order: 8,
  //       route: 'em-desenvolvimento',
  //     },
  //     {
  //       displayName: 'Prazos',
  //       iconName: 'navigate_next',
  //       roles: ['PROPG'],
  //       order: 9,
  //       route: 'em-desenvolvimento',
  //     },
  //     {
  //       displayName: 'Prazos Cumpridos',
  //       iconName: 'navigate_next',
  //       roles: ['PROPG'],
  //       order: 10,
  //       route: 'em-desenvolvimento',
  //     },
  //   ],
  // },
  // {
  //   displayName: 'Calendário',
  //   iconName: 'calendar_month',
  //   roles: ['PROPG'],
  //   order: 11,
  //   route: 'em-desenvolvimento',
  // },
  // {
  //   displayName: 'Rol de Disciplinas',
  //   iconName: 'format_list_bulleted',
  //   roles: ['PROPG'],
  //   order: 12,
  //   children: [
  //     {
  //       displayName: 'Oferecimento de Turmas',
  //       iconName: 'navigate_next',
  //       roles: ['PROPG'],
  //       order: 1,
  //       route: 'em-desenvolvimento',
  //     },
  //     {
  //       displayName: 'Processamento Matrícula Portfólio',
  //       iconName: 'navigate_next',
  //       roles: ['PROPG'],
  //       order: 2,
  //       route: 'em-desenvolvimento',
  //     },
  //   ],
  // },
  // {
  //   displayName: 'Participante Externo',
  //   iconName: 'supervised_user_circle',
  //   roles: ['PROPG'],
  //   order: 14,
  //   route: 'em-desenvolvimento',
  // },
  // {
  //   displayName: 'Mensagens',
  //   iconName: 'mail',
  //   roles: ['PROPG'],
  //   order: 14,
  //   addBottomDivider: true,
  //   children: [
  //     {
  //       displayName: 'Recebidas',
  //       iconName: 'navigate_next',
  //       roles: ['PROPG'],
  //       order: 1,
  //       route: 'em-desenvolvimento',
  //     },
  //     {
  //       displayName: 'Enviadas',
  //       iconName: 'navigate_next',
  //       roles: ['PROPG'],
  //       order: 2,
  //       route: 'em-desenvolvimento',
  //     },
  //   ],
  // },
  // // PUBLICO
  // {
  //   displayName: 'Autenticidade de documento',
  //   iconName: 'qr_code_scanner',
  //   roles: [ROLE_WILDCARD_PUBLIC],
  //   route: 'autenticidade-documento',
  //   order: 998,
  // },
  // CADASTROS
  {
    displayName: 'Mobilidades',
    iconName: 'travel_explore',
    roles: ['PROPG'],
    order: 987,
    children: [
      {
        displayName: 'Tipo Mobilidade',
        iconName: 'description',
        roles: ['PROPG'],
        order: 1,
        route: 'propg/mobilidade/tipo-mobilidade',
      },
      {
        displayName: 'Outgoing',
        iconName: 'move_up',
        roles: ['PROPG'],
        order: 2,
        route: 'propg/mobilidade/outgoing',
      },
      {
        displayName: 'Incoming',
        iconName: 'move_down',
        roles: ['PROPG'],
        order: 3,
        route: 'propg/mobilidade/incoming',
      },
    ],
  },
  {
    displayName: 'Portfólio',
    iconName: 'snippet_folder',
    roles: ['PROPG'],
    order: 988,
    children: [
      {
        displayName: 'Desefetivar Turmas',
        iconName: 'group_off',
        roles: ['PROPG'],
        order: 1,
        route: 'propg/portfolio/desefetivar-turmas',
      },
    ],
  },
  // {
  //   displayName: 'Processo Seletivo Unificado',
  //   iconName: 'upload_file',
  //   roles: ['PROPG'],
  //   order: 988,
  //   children: [
  //     {
  //       displayName: 'Importar',
  //       iconName: 'upload_file',
  //       roles: ['PROPG'],
  //       order: 1,
  //       route: 'propg/processo-seletivo-unificado/importar',
  //     },
  //   ],
  // },
  // LOGs
  {
    displayName: 'LOGs',
    iconName: 'manage_search',
    roles: ['PROPG'],
    route: 'propg/logs',
    order: 989,
  },
  {
    displayName: 'Perfis',
    iconName: 'person_pin',
    roles: ['PROPG'],
    route: 'propg/perfis',
    order: 990,
    addBottomDivider: true,
  },
  // PUBLICO
  {
    displayName: 'Processo seletivo',
    iconName: 'grading',
    roles: [ROLE_WILDCARD_PUBLIC],
    route: 'processo-seletivo',
    order: 997,
    children: [
      {
        displayName: 'Aluno regular',
        iconName: 'edit_note',
        roles: [ROLE_WILDCARD_PUBLIC],
        order: 1,
        route: 'processo-seletivo/aluno-regular',
      },
      {
        displayName: 'Aluno especial',
        iconName: 'edit_note',
        roles: [ROLE_WILDCARD_PUBLIC],
        order: 2,
        route: 'processo-seletivo/aluno-especial',
      },
    ],
  },
  {
    displayName: 'Autenticidade de documento',
    iconName: 'qr_code_scanner',
    roles: [ROLE_WILDCARD_PUBLIC],
    route: 'autenticidade-documento',
    order: 998,
  },
  {
    displayName: 'Ajuda/Suporte',
    iconName: 'contact_support',
    roles: [ROLE_WILDCARD_PUBLIC],
    route: 'ajuda/suporte',
    order: 999,
  },
  {
    displayName: 'Voltar ao portal',
    iconName: 'home',
    roles: [ROLE_WILDCARD_PUBLIC],
    route: 'voltar-portal',
    order: 1000,
  },
]
